__turbopack_context__.v({
  "fade-in": "DataList-module-scss-module__AW5V4a__fade-in",
  "label": "DataList-module-scss-module__AW5V4a__label",
  "list": "DataList-module-scss-module__AW5V4a__list",
  "no-transform": "DataList-module-scss-module__AW5V4a__no-transform",
  "rotate": "DataList-module-scss-module__AW5V4a__rotate",
  "value": "DataList-module-scss-module__AW5V4a__value",
});
